import { InMemoryCache } from '@apollo/client'
import introspection from './introspection'

import fields from './reactive-variables'

export const cache: InMemoryCache = new InMemoryCache( {
	possibleTypes: introspection.possibleTypes,
	typePolicies: {
		Query: {
			fields,
		},
	},
} )

export default cache
